import {
  getDevice
} from "./chunk-GGTT5G5Y.mjs";
import {
  getInstallId
} from "./chunk-XKGJ4NUN.mjs";
import {
  getUserId
} from "./chunk-DV6UH3SA.mjs";
import {
  getGeo
} from "./chunk-R4DOYUVG.mjs";
import {
  getSessionId
} from "./chunk-FZO3U2FN.mjs";

// src/contexts/initialize-context/initialize-context.ts
async function initializeContext({ initializedCallback, readyCallback } = {}) {
  if (window.yvaDatastore && window.yvaDatastore.contexts) {
    let newContextId = self.crypto.randomUUID();
    window.yvaDatastore.contexts[newContextId] = { data: { device: {} }, status: "initialized" };
    window.yvaDatastore.currentContextId = newContextId;
    if (initializedCallback) {
      initializedCallback();
    }
    try {
      const promiseResults = await Promise.allSettled([
        getInstallId(),
        getGeo(),
        getSessionId(),
        getDevice(),
        getUserId()
      ]);
      const emptyPrePromiseResults = {
        browser: {},
        device: { platform: "", type: "UNKNOWN" },
        geo: {
          city: null,
          country: null,
          region: null
        },
        installId: "",
        sessionId: "",
        userId: null
      };
      const { installId, geo, sessionId, browser, device, userId } = promiseResults.reduce(
        (contextData, promiseResult, index) => {
          switch (index) {
            /** `getInstallId`. */
            case 0:
              if (promiseResult.status === "fulfilled") {
                contextData.installId = promiseResult.value;
              }
              break;
            /** `getGeo`. */
            case 1:
              if (promiseResult.status === "fulfilled") {
                contextData.geo = promiseResult.value;
              }
              break;
            /** `getSessionId`. */
            case 2:
              if (promiseResult.status === "fulfilled") {
                contextData.sessionId = promiseResult.value;
              }
              break;
            /** `getDevice`. */
            case 3:
              if (promiseResult.status === "fulfilled") {
                const { browser: browser2, device: device2 } = promiseResult.value;
                contextData.browser = browser2;
                contextData.device = device2;
              }
              break;
            /** `getUserId`. */
            case 4:
              if (promiseResult.status === "fulfilled") {
                contextData.userId = promiseResult.value;
              }
              break;
            default:
          }
          return contextData;
        },
        emptyPrePromiseResults
      );
      window.yvaDatastore.contexts[newContextId] = {
        data: {
          app_version: window.yvaDatastore.config.appVersion,
          application_id: window.yvaDatastore.config.applicationId,
          browser,
          client_id: window.yvaDatastore.config.clientId,
          device: { ...device, installation_id: installId },
          geo,
          network_interface_type: navigator.onLine ? "online" : "offline",
          session_id: sessionId,
          user_id: userId
        },
        status: "ready"
      };
      if (readyCallback) {
        readyCallback();
      }
      return;
    } catch (error) {
      if (window.yvaDatastore.config.debug) {
        console.error("Error initializing context", newContextId);
        console.dir(error, { depth: null });
      }
      return;
    }
  }
}

export {
  initializeContext
};
